import React from "react";
import { ReactComponent as Logo } from '../assets/logo.svg';
import { FaFacebook, FaInstagram } from "react-icons/fa";

const Footer = () => {
	const redes = [
		{ icon: FaFacebook, url: "https://www.facebook.com/people/In-Mobile-Arquitectos/100069402460028/" },
		{ icon: FaInstagram, url: "https://www.instagram.com/arquitectosinmobile?igsh=Nno3NHdjbXVrdG84" },
	];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-amber-500 shadow text-white">
			<div className="grid grid-cols-2 md:grid-cols-3">
				<div className="w-full flex justify-center items-center">
					<Logo className="h-32" />
				</div>

				<div className="grid place-items-center gap-2 text-center">
					<h2>Avenida 47 Poniente 707, Oficina Nº1, Col. Prados Agua Azul</h2>
					<p>Puebla de Zaragoza, México. C.P. 72430</p>
					<p>Teléfono: 221 199 4725</p>
				</div>

				<div className="grid place-items-center gap-2 text-center">
					<h2>Dirección</h2>
					<p>
						Aportamos orgullo y pasión a cada proyecto que emprendemos, con un equipo profesional.
					</p>

					{/* REDES */}
					<div className="flex gap-4 mt-2">
						{redes.map((red, index) => {
							const Icon = red.icon;
							return (
								<a
									key={index}
									href={red.url}
									target="_blank"
									rel="noopener noreferrer"
									className="text-2xl hover:scale-110 transition"
								>
									<Icon />
								</a>
							);
						})}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;